import React from "react";

export default class ApiSectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unknown error" };
  }

  componentDidCatch(error, info) {
    console.error("ApiSectionErrorBoundary", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-ds-xl border border-warning/40 bg-warning/10 p-4 text-sm text-fg" role="alert">
          <p className="font-semibold">Live data panel failed to render.</p>
          <p className="mt-1 text-xs text-fg-secondary">{this.state.message}</p>
        </div>
      );
    }
    return this.props.children;
  }
}
